import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { decryptData } from '../../utils/storageCrypto';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import { createPortal } from 'react-dom';


 export default function ProductPrice() {
      const navigate = useNavigate();

  const [showPopupMessages, setShowPopupMessages] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [retryFunction, setRetryFunction] = useState(null);
  const [Loading, setIsLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);

  
    useEffect(() => {
        fetchData();
    }, []); 

    const fetchData = async () => {
      const URL = process.env.REACT_APP_FORE_NOTIFY;
    
      try {
        const enrecipientId = sessionStorage.getItem('userId');
        const enrecipientRole = sessionStorage.getItem('roleId');
        const encryptedToken = sessionStorage.getItem('token');
        console.log(enrecipientId, enrecipientRole, encryptedToken);
        if (!enrecipientId || !enrecipientRole || !encryptedToken) {
          setPopupMessage("Session expired. Please login again.");
          setPopupType("401");
          setShowPopupMessages(true);
          return;
        }
    
        const recipientId = decryptData(enrecipientId);
        const recipientRole = decryptData(enrecipientRole);
        const token = decryptData(encryptedToken);
    
        console.log("decrpted:", recipientId, recipientRole, token);
    
        if (!recipientId || /* !recipientRole || */ !token) {
          setPopupMessage("Invalid session data. Please login again.");
          setPopupType("401");
          setShowPopupMessages(true);
          return;
        }
    
        const response = await fetch(
          `${URL}notifications/get-all-active-price-notifications?recipientId=${recipientId}&recipientRole=${recipientRole}`,
          {
            headers: {
              'x-token': token
            }
          }
        );
    
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          setPopupMessage(errorData.message || "Failed to fetch notifications");
          setPopupType(response.status === 401 ? "401" : response.status === 403 ? "403" : "400");
          setShowPopupMessages(true);
          setRetryFunction(() => fetchData);
          return;
        }
    
        const data = await response.json();

        console.log("data:",data)
    
        if (data.success) {
          setNotifications(data.notifications || []);
        } else {
          setPopupMessage(data.message || "Failed to load notifications");
          setPopupType("400");
          setShowPopupMessages(true);
          setRetryFunction(() => fetchData);
        }
    
      } catch (err) {
        setPopupMessage(err.message || "Something went wrong");
        setPopupType("500");
        setShowPopupMessages(true);
        setRetryFunction(() => fetchData);
      }
    };

      const BackToLoginPage = () => {

    setShowPopupMessages(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };

  const closePopup = () => {
    setShowPopupMessages(false);
  };

  const Retry = async () => {
    setIsLoading(true); // Show loader
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction(); // Call retry function
      }
      setIsLoading(false); // Hide loader after retry
    }, 5000); // 5-second delay
    setShowPopupMessages(false);
  };


  // Edit logic (you can customize navigation or modal)
const handleEdit = (notif) => {
  console.log("Edit clicked:", notif);

  if(notif.entity.toLowerCase() === 'vendor_price' || notif.entity.toLowerCase() === 'bp' || notif.entity.toLowerCase() === 'moq'){
    updateProductPrice(notif.entityId,notif._id);
  }else if(notif.entity.toLowerCase() === 'discount_slab'){
    const meta_data=notif?.metadata;
    console.log("Meta data:", meta_data);
    const productIds = meta_data.productIds/* products.map(p => p.id) */;
    const discount = meta_data.best_discount;
    updatePricesFromDiscount(productIds, discount,notif._id);
  }else{
    setPopupMessage("Unknown notification type. Cannot update price.");
    setPopupType("400");
    setShowPopupMessages(true);
  }
};

// Dismiss logic
const handleDismiss = (id) => {

  console.log("Dismissed:", id);
  rejectBestPrice(id, false);
};


const updateProductPrice = async (productId, notificationId) => {
  const URL = process.env.REACT_APP_FORE_BRICKBUCKET;
  const encryptedToken = sessionStorage.getItem('token');
  const token = decryptData(encryptedToken);
  try {
    const response = await fetch(
       `${URL}product/update-product-price-from-vendors?product_id=${productId}&notification_id=${notificationId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        }
      }
    );

    const data = await response.json();

/*     if (!response.ok) {
      throw new Error(data.message || "Failed to update product price");
    } */

    console.log("✅ Success:", data);
        if (response.ok) {

      setPopupMessage(data.message || "Success");
      setPopupType("200or201");
      setShowPopupMessages(true);
       setTimeout(() => {
        setShowPopupMessages(false);
      }, 3000);


      // remove notification
        fetchData();

    } else {

      setPopupMessage(data.message || "Failed");
      setPopupType("400");
      setShowPopupMessages(true);

    }

  } catch (error) {
    console.error("❌ Error:", error.message);
    setPopupMessage(error.message || "Error occurred");
    setPopupType("500");
    setShowPopupMessages(true);
  }
};


const updatePricesFromDiscount = async (productIds, discount, notificationId) => {
  const URL = process.env.REACT_APP_FORE_BRICKBUCKET;
  const encryptedToken = sessionStorage.getItem('token');
  const token = decryptData(encryptedToken);
  try {
    const response = await fetch(
       `${URL}discount/update-product-prices-from-discount`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify({
          product_ids: productIds,
          discount: discount,
          notification_id: notificationId
        })
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to update prices");
    }

    console.log("✅ Success:", data);
    if (response.ok) {

      setPopupMessage(data.message || "Success");
      setPopupType("200or201");
      setShowPopupMessages(true);
       setTimeout(() => {
        setShowPopupMessages(false);
      }, 3000);


      // remove notification
        fetchData();

    } else {

      setPopupMessage(data.message || "Failed");
      setPopupType("400");
      setShowPopupMessages(true);

    }
  } catch (error) {
    console.error("❌ Error:", error.message);
    setPopupMessage(error.message || "Error occurred");
    setPopupType("500");
    setShowPopupMessages(true);
  }
};


 const rejectBestPrice = async (id, acceptValue) => {
  console.log(id)
  try {
      const fetchURL = process.env.REACT_APP_FORE_BRICKBUCKET;
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const notification_id = id || null;
   const quotation_id = null;

  console.log(acceptValue,quotation_id);

    const response = await fetch(
      `${fetchURL}customer/quotations/accept-or-reject-best-prices`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify({
          accept: acceptValue,
          quotation_id: quotation_id,
          notification_id:notification_id
        })
      }
    );
    console.log("Request body:", {
      accept: acceptValue,
      quotation_id: quotation_id
    });

    console.log("accept/reject response:", response);

    const data = await response.json();

    if (response.ok) {

      setPopupMessage(data.message || "Success");
      setPopupType("200or201");
      setShowPopupMessages(true);
       setTimeout(() => {
        setShowPopupMessages(false);
      }, 3000);


      // remove notification
        fetchData();

    } else {

      setPopupMessage(data.message || "Failed");
      setPopupType("400");
      setShowPopupMessages(true);

    }

  } catch (err) {

    setPopupMessage(err.message || "Error occurred");
    setPopupType("500");
    setShowPopupMessages(true);

  } 
};

return (
  <div className="h-full bg-gray-50 p-6 flex justify-center">
    
    {/* CONTENT CONTAINER */}
    <div className="w-full max-w-6xl bg-white shadow-md rounded-lg p-6">

      {/* TABLE */}
      <h2 className="text-xl font-semibold mb-4">Price Notifications</h2>

      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 table-fixed">
          
          <thead className="bg-gray-100">
            <tr>
              <th className="w-1/4 border px-4 py-2 text-left">Title</th>
              <th className="w-2/4 border px-4 py-2 text-left">Message</th>
              <th className="w-1/4 border px-4 py-2 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {notifications.length > 0 ? (
              notifications.map((notif) => (
                <tr key={notif._id} className="hover:bg-gray-50 align-middle">
                  
                  <td className="border px-4 py-2 break-words">
                    {notif.title}
                  </td>

                  <td className="border px-4 py-2 break-words">
                    {notif.message}
                  </td>

                  <td className="border px-4 py-2">
                    <div className="flex justify-center items-center gap-2">
                      
                      <button
                        className=" border border-blue-600 hover:bg-blue-600 hover:text-white px-3 py-1 rounded text-sm"
                        onClick={() => handleEdit(notif)}
                      >
                        Update Price
                      </button>

                      <button
                        className=" border border-red-600 hover:bg-red-600 hover:text-white px-3 py-1 rounded text-sm"
                        onClick={() => handleDismiss(notif._id)}
                      >
                        Dismiss
                      </button>

                    </div>
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center py-4">
                  No Price Notifications Found
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>

      {/* POPUPS */}
      {showPopupMessages &&
        createPortal(
          <div className="fixed inset-0 z-[99999]">
            {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
            {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
            {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
            {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
            {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
            {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
          </div>,
          document.body
        )
      }

    </div>
  </div>
);

} 
